var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3180_28367)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5459,
    y: 44.1816,
    width: 3.81818,
    height: 3.81818,
    fill: "#EFF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0908 22.5455C29.0908 21.1396 30.2305 20 31.6363 20H49.4545C50.8603 20 51.9999 21.1396 51.9999 22.5455V45.4545C51.9999 46.8604 50.8603 48 49.4545 48H29.0908V22.5455Z",
    fill: "#EFF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 32.7271C24 32.0242 24.5698 31.4543 25.2727 31.4543H29.0909V45.4543C29.0909 46.8602 27.9513 47.9998 26.5455 47.9998C25.1396 47.9998 24 46.8602 24 45.4543V32.7271Z",
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.3193,
    y: 23,
    width: 17,
    height: 8,
    rx: 1.27273,
    fill: "#FFA692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9092 35L48.1819 35",
    stroke: "#8BA293",
    strokeWidth: 1.78182,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9089 39.0906L48.1817 39.0906",
    stroke: "#8BA293",
    strokeWidth: 1.78182,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9092 43.1816L48.1819 43.1816",
    stroke: "#8BA293",
    strokeWidth: 1.78182,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3180_28367",
    x: -6,
    y: -6,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.133333 0 0 0 0 0.156863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3180_28367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3180_28367",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapper);
export default __webpack_public_path__ + "static/media/papper.2c74d8b9ab260e319c7b7210ae4fd866.svg";
export { ForwardRef as ReactComponent };